import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollUpComp() {
  const location = useLocation();

  useEffect(() => {
    if (!window) return;
    if (!location?.state?.dontScrollUp) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
}
